import { render, staticRenderFns } from "./open.vue?vue&type=template&id=48941345&scoped=true&"
import script from "./open.js?vue&type=script&lang=js&"
export * from "./open.js?vue&type=script&lang=js&"
import style0 from "./open.scss?vue&type=style&index=0&id=48941345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48941345",
  null
  
)

export default component.exports